import {
  CANCEL_FAILURE,
  CANCEL_REQUEST,
  CANCEL_RESET,
  CANCEL_SUCCESS,
} from "../actions/cancel";

const initialState = {
  state: "idle",
};

export default function cancelDoc(state = initialState, action: any) {
  switch (action.type) {
    case CANCEL_REQUEST:
      return { ...state, state: "loading" };
    case CANCEL_SUCCESS:
      return { ...state, ...action.payload, state: "success" };
    case CANCEL_FAILURE:
      return { ...state, ...action.payload, state: "failure" };
    case CANCEL_RESET:
      return { ...state, state: "idle" };
    default:
      return state;
  }
}
